(function () {
  if (window.customElements && customElements.get('reviews-carousel')) return;

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  class ReviewsVideo extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.video = this.querySelector('video');
      this._setState('idle');

      if (!this.video) return; // poster-only card: no controls, no state machine

      var playBtn = this.querySelector('[data-play]');
      var muteBtn = this.querySelector('[data-mute]');

      if (playBtn) playBtn.addEventListener('click', this.toggle.bind(this));
      if (muteBtn) muteBtn.addEventListener('click', this.toggleMute.bind(this));

      var addBtn = this.querySelector('[data-quick-add]');
      if (addBtn) addBtn.addEventListener('click', this.pause.bind(this));

      this.video.addEventListener('play', function () { this._setState('playing'); }.bind(this));
      this.video.addEventListener('pause', function () {
        if (!this.video.ended) this._setState('paused');
      }.bind(this));
      this.video.addEventListener('ended', function () {
        this.video.currentTime = 0;
        this._setState('idle');
      }.bind(this));
      this.video.addEventListener('error', function () {
        this._setState('error');
        console.warn('[reviews] video failed to load', this.video && this.video.currentSrc);
      }.bind(this));

      this._syncMuted();
    }

    _setState(state) { this.dataset.state = state; }

    _syncMuted() {
      if (this.video) this.dataset.muted = this.video.muted ? 'true' : 'false';
    }

    play() {
      if (!this.video || this.dataset.state === 'error') return;
      this._setState('loading');
      var p = this.video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () { if (this.dataset.state !== 'playing') this._setState('idle'); }.bind(this));
      }
    }

    pause() { if (this.video && !this.video.paused) this.video.pause(); }

    toggle() {
      if (!this.video) return;
      if (this.video.paused) this.play();
      else this.pause();
    }

    toggleMute() {
      if (!this.video) return;
      this.video.muted = !this.video.muted;
      this._syncMuted();
    }
  }

  class ReviewsCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';

      this._boot = this._boot.bind(this);
      if (typeof Swiper !== 'undefined') this._boot();
      else window.addEventListener('load', this._boot, { once: true });
    }

    _boot() {
      if (this._swiper || typeof Swiper === 'undefined') return;

      var el = this.querySelector('[data-reviews-swiper]');
      if (!el) return;

      var inf = this._setupInfinite(el);

      this._swiper = new Swiper(el, {
        slideClass: 'shopify-block',
        slidesPerView: 'auto',
        centeredSlides: true,
        initialSlide: inf.stride,
        slidesPerGroup: 1,
        slideToClickedSlide: true,
        spaceBetween: 12,
        watchSlidesProgress: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        keyboard: { enabled: true },
        navigation: {
          prevEl: this.querySelector('[data-reviews-prev]'),
          nextEl: this.querySelector('[data-reviews-next]')
        },
        scrollbar: {
          el: this.querySelector('[data-reviews-bar]'),
          draggable: true
        },
        breakpoints: {
          0: { spaceBetween: 6 },
          990: { spaceBetween: 12 }
        }
      });

      var self = this;
      this._swiper.on('slideChangeTransitionStart', function (sw) {
        sw.updateSlides();
        sw.updateProgress();
        sw.setTranslate(-sw.snapGrid[sw.activeIndex]);
        self._animateSize(sw);
      });

      if (inf.stride) {
        this._swiper.on('slideChangeTransitionEnd', function (sw) {
          var target = -1;
          if (sw.activeIndex >= inf.stride * 2) target = sw.activeIndex - inf.stride;
          else if (sw.activeIndex < inf.stride) target = sw.activeIndex + inf.stride;
          if (target < 0) return;
          sw.slideTo(target, 0, false);
          sw.updateSlides();
          sw.setTranslate(-sw.snapGrid[sw.activeIndex]);
        });
      }

      this._initVideos();
    }

    _animateSize(sw) {
      var actif = sw.slides[sw.activeIndex];
      var precedent = sw.slides[sw.previousIndex];
      if (!actif) return;

      var carteActive = actif.querySelector('.reviews-vcard');
      if (!carteActive) return;
      var largeurActive = carteActive.getBoundingClientRect().width;

      var largeurVoisine = 0;
      for (var i = 0; i < sw.slides.length; i++) {
        if (i === sw.activeIndex) continue;
        var c = sw.slides[i].querySelector('.reviews-vcard');
        if (c) { largeurVoisine = c.getBoundingClientRect().width; break; }
      }
      if (!largeurActive || !largeurVoisine || largeurActive === largeurVoisine) return;

      this._flip(carteActive, largeurVoisine / largeurActive);
      if (precedent && precedent !== actif) {
        var cartePrecedente = precedent.querySelector('.reviews-vcard');
        this._flip(cartePrecedente, largeurActive / largeurVoisine);
      }
    }

    _flip(carte, ratio) {
      if (!carte || !ratio || ratio === 1) return;
      carte.style.transition = 'none';
      carte.style.transform = 'scale(' + ratio + ')';
      void carte.offsetWidth;
      carte.style.transition = '';
      carte.style.transform = '';
    }

    _setupInfinite(el) {
      var none = { stride: 0, count: 0 };
      var wrapper = el.querySelector('.swiper-wrapper');
      if (!wrapper) return none;

      var originals = Array.prototype.filter.call(wrapper.children, function (n) {
        return n.classList.contains('shopify-block') && !n.hasAttribute('data-reviews-clone');
      });
      if (originals.length < 2) return none; // une seule carte : rien a faire tourner

      var slotW = originals[0].getBoundingClientRect().width + 12; // + spaceBetween max
      var containerW = el.clientWidth;
      if (!slotW || !containerW) return none;

      var n = originals.length;
      var perView = Math.ceil(containerW / slotW) + 1;
      var halfWindow = Math.ceil(perView / 2) + 1;
      var stride = n * Math.ceil(halfWindow / n);
      var total = stride * 3;

      while (wrapper.querySelectorAll('.shopify-block').length < total) {
        for (var i = 0; i < n; i++) wrapper.appendChild(this._cloneSlide(originals[i]));
      }
      return { stride: stride, count: total };
    }

    _cloneSlide(node) {
      var clone = node.cloneNode(true);
      clone.setAttribute('data-reviews-clone', '');
      clone.removeAttribute('id');
      clone.removeAttribute('data-shopify-editor-block');
      var tagged = clone.querySelectorAll('[data-shopify-editor-block], [id]');
      Array.prototype.forEach.call(tagged, function (n) {
        n.removeAttribute('data-shopify-editor-block');
        n.removeAttribute('id');
      });
      var video = clone.querySelector('video');
      if (video) video.preload = 'none';
      return clone;
    }

    _initVideos() {
      var players = Array.prototype.slice.call(this.querySelectorAll('reviews-video'));
      var withVideo = players.filter(function (p) { return p.querySelector('video'); });
      if (!withVideo.length) return;

      var autoplay = this.dataset.autoplay === 'true' && !REDUCED_MOTION.matches;

      if ('IntersectionObserver' in window) {
        this._pauseIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) entry.target.pause();
          });
        }, { threshold: 0 });
        withVideo.forEach(function (p) { this._pauseIo.observe(p); }, this);

        if (autoplay) {
          this._playIo = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) entry.target.play();
            });
          }, { threshold: 0.5 });
          withVideo.forEach(function (p) { this._playIo.observe(p); }, this);
        }
      }
    }

    disconnectedCallback() {
      if (this._playIo) this._playIo.disconnect();
      if (this._pauseIo) this._pauseIo.disconnect();
      if (this._swiper && this._swiper.destroy) this._swiper.destroy(true, true);
      this._swiper = null;
      this.dataset.initialized = '';
    }
  }

  customElements.define('reviews-video', ReviewsVideo);
  customElements.define('reviews-carousel', ReviewsCarousel);
})();
